import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import { CircularProgress } from "@material-ui/core";
import jsPDF from "jspdf";
import moment from "moment";
import "moment/locale/fr";

const ResumeTemplate1 = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidateId] = useState("");
  const [candidate, setCandidate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [initials, setInitials] = useState("");

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidateId(candidate?.id);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId != "") {
      if (storeCandidate.candidate === null) {
        setIsLoading(true);
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setIsLoading(false);
        });
      } else if (storeCandidate.candidate !== null) {
        setIsLoading(true);
        setCandidate(storeCandidate.candidate);
        setIsLoading(false);
      }
    }
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".template-page"), {
      callback: (doc) => doc.save("resume.pdf"),
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="template-page">
            <style>
              {`
                  
          :root {
            --color-black: #2379B8;
            --color-white: #F5F5F5;
          }



          body {
            font-family: 'Arial', sans-serif;    
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #222;
          }

          .wrap {
            width: 90% !important;
            margin: 10px auto !important;
            padding: 30px !important;
            margin-bottom: 40px;
            
          }

          header {
            padding: 50px 0;
            text-align: center;
            background-color: var(--color-black);
            color: var(--color-white);
          }

          header h6 {
            letter-spacing: 2px;
            font-weight: normal;
            margin-top: 0;
            text-transform: uppercase;
          }

          header h1 {
            letter-spacing: 4px;
            text-transform: uppercase;
            color: #fff !important;
          }

          header .job {
            font-size: 12px;
            letter-spacing: 2px;
            border: 1px solid var(--color-white);
            background-color: var(--color-black);
            display: inline-block;
            padding: 6px 10px;
            text-transform: uppercase;
          }

          header .hr {
            border-bottom: 1px solid var(--color-white);
            width: 70%;
            margin: -12px auto 0;
          }

          .content {
            color: var(--color-black);
            margin-bottom: 40px !important;
          }

          .title {
            font-weight: 800;
            letter-spacing: 2px;
            padding-bottom: 5px;
            margin: 0 0 7px;
            border-bottom: 1px solid #666;
            text-transform: uppercase;
          }

          aside {
            float: left;
            width: 35%;
            height: 1200px;
            padding: 60px;
            background-color: #E6E6E6;
          }

          .photo {
            width: 220px;
            height: 220px;
            border-radius: 50%;
            margin: 0 auto 50px;
            background-color: var(--color-white);
            background-size: cover;
            background-position: 30% center;
            filter: grayscale(100%);
            position: relative; /* Add position relative to .photo */
          }

          .profile-avatar {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden; /* Hide overflow to keep circular shape */
          }

          .profile-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover; /* Ensure the image covers the entire area */
            border-radius: 50%; /* Maintain circular shape */
          }


          section {
            margin: 0 0 30px -30px;
          }



          .subtitle {
            margin: 0;
            display: inline-block;
            width: 35%;
            vertical-align: top;
          }

          .ans {
            display: inline-block;
            width: 70%;
            font-size: 13px;
            color: #666;
            vertical-align: top;
            margin: 10px;
          }



          .icon {
            width: 40px;
            height: 40px;
            font-size: 24px;
            border-radius: 50%;
            text-align: center;
            padding-top: 5px;
            color: #E6E6E6;
            background-color: var(--color-black);
          }

          .main {
            float: left;
            width: 65%;
            height: 1200px;
            padding: 50px;
            background-color: var(--color-white);
          }

          .main p {
            color: #666;
            font-size: 14px;
            line-height: 1.4;
            text-align: justify;
          }

          .circle {
            display: inline-block;
            position: relative;
            margin: 20px 20px 0 0;
            text-align: center;
          }

          .skl {
            font-size: 15px;
            font-weight: 700;
            color: #E6E6E6;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
          }

          .pie {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background-color: var(--color-black);
            position: relative;
            overflow: hidden;
          }

          .pie:after {
            content: "";
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background-color: var(--color-white);
            position: absolute;
            top: 0;
            left: 0;
            transform: scale(0.8);
          }


          .square {
            width: 100px;
            height: 100px;
            background-color: transparent;
            position: absolute;
            left: 0;
            top: 0;
            clip-path: polygon(50% 50%, 50% 0, 0 0, 0 100%);
            transform: rotate(-90deg); /* Start from top */
          }

          .square1 {
            background-color: var(--color-black);
          }

          .square2 {
            background-color: #CCC;
          }

          .square3 {
            background-color: #CCC;
          }

          .square4 {
            background-color: #CCC;
          }

          .timeline {
            margin: 20px 0 50px;
          }

          .timeline ul,
          .timeline li {
            padding: 0;
            margin: 0;
            list-style: none;
          }

          .timeline time {
            display: inline-block;
            width: 50px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 14px;
            color: var(--color-white);
            background-color: var(--color-black);
            position: relative;
            top: -4px;
            left: -100px;
          }

          .timeline time:after {
            content: "";
            position: absolute;
            right: -10px;
            display: inline-block;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 10px solid var(--color-black);
          }

          .timeline h5 {
            margin: 0;
            margin-top: -22px;
            margin-bottom: -10px;
            letter-spacing: 1px;
            font-weight: 800;
          }

          .timeline li {
            position: relative;
            padding-left: 100px;
          }

          .timeline li:before {
            content: "";
            width: 4px;
            height: 100%;
            padding-bottom: 30px;
            background: #CCC;
            position: absolute;
            left: 70px;
          }

          .timeline li:after {
            content: "";
            position: absolute;
            top: 0;
            left: 68px;
            z-index: 10;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: var(--color-black);
          }

          .software {
            margin-top: 5px;
            clear: both;
          }

          .software ul,
          .software li {
            margin: 0;
            padding: 0;
            list-style: none;
          }

          .software li {
            font-size: 12px;
            font-weight: 600;
            width: 45%;
            float: left;
            margin-bottom: 30px;
            position: relative;
          }

          .software li:nth-child(odd) {
            margin-right: 10%;
          }

          .software li:before {
            content: "";
            width: 100%;
            height: 15px;
            display: inline-block;
            background: #CCC;
            position: absolute;
            left: 0;
            top: 0;
            margin-top: 15px;
            z-index: 0;
          }

          .software li:after {
            content: "";
            width: 50%;
            height: 15px;
            display: inline-block;
            background: #CCC;
            position: absolute;
            left: 0;
            top: 0;
            margin-top: 15px;
            z-index: 10;
          }

          .software .per1:after { width: 85%; }
          .software .per2:after { width: 70%; }
          .software .per3:after { width: 65%; }
          .software .per4:after { width: 90%; }
          .software .per5:after { width: 40%; }
          .software .per6:after { width: 50%; }

          .button-container {
            position: fixed;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .btn {
              padding: 12px 20px;
              font-size: 16px;
              cursor: pointer;
              border: none;
              border-radius: 5px;
              color: #fff;
              background-color: #333;
          }

          .btn-download {
              background-color: #5cb85c;
          }
                    
        /* Media Queries for Print */
        @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .button-container, footer {
              display: none;
            }
          .subtitle {
            margin: 0;
            display: inline-block;
            width: 35%;
            vertical-align: top;
          }

          .ans {
            display: inline-block;
            width: 70%;
            font-size: 13px;
            color: #666;
            vertical-align: top;
            margin: 10px;
          }
            .photo {
            width: 220px;
            height: 220px;
            border-radius: 50%;
            margin: 0 auto 50px;
            background-color: var(--color-white);
            background-size: cover;
            background-position: 30% center;
            filter: grayscale(100%);
            position: relative; /* Add position relative to .photo */
          }

          .profile-avatar {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden; /* Hide overflow to keep circular shape */
          }

          .profile-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover; /* Ensure the image covers the entire area */
            border-radius: 50%; /* Maintain circular shape */
          }


        }


      `}
            </style>
            <div className="wrap">
              <header>
                <h1 className="cv-name">
                  {candidate?.firstName} {candidate?.lastName}
                </h1>
                <div className="hr"></div>
              </header>
              <div className="content">
                <aside>
                  <div className="photo">
                    <div className="profile-avatar">
                      {candidate?.profilePictureUrl ? (
                        <>
                          <img
                            className="img-fluid"
                            src={candidate?.profilePictureUrl}
                            alt={`${candidate?.firstName} ${candidate?.lastName}`}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            className="img-fluid"
                            src="assets/images/avatar/avatar2.png"
                            alt="Avatar"
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <section>
                    <h3 className="title">contact</h3>
                    <ul>
                      <li>
                        <h5 className="subtitle">Téléphone</h5>
                        <div className="ans">{candidate?.phoneNumber1}</div>
                      </li>

                      <li>
                        <h5 className="subtitle">Email</h5>
                        <div className="ans">{candidate?.email}</div>
                      </li>
                    </ul>
                  </section>
                  <section>
                    <h3 className="title">Langues</h3>
                    <ul>
                      {candidate?.languages.map((language, index) => (
                        <li key={index}>
                          <h5 className="subtitle">{language.name}</h5>
                          <div className="ans">{language.percentage}</div>
                        </li>
                      ))}
                    </ul>
                  </section>
                </aside>
                <main className="main">
                  <section>
                    <h3 className="title">profile</h3>
                    <div
                      className="html-content summary-content"
                      dangerouslySetInnerHTML={{ __html: candidate?.summary }}
                    />
                    <div className="ability">
                      <div className="ability">
                        {candidate?.skills && candidate?.skills.length > 0
                          ? candidate?.skills.map((skill, index) => (
                              <div className="circle" key={index}>
                                <div className="skl">
                                  {skill?.title.slice(0, 2).toUpperCase()}
                                </div>
                                <div
                                  className="pie"
                                  style={{ "--percentage": skill?.percentage }}
                                >
                                  <div
                                    className="square square1"
                                    style={{
                                      display:
                                        skill?.percentage > 0
                                          ? "block"
                                          : "none",
                                      transform: `rotate(${
                                        (360 *
                                          Math.min(skill?.percentage, 100)) /
                                        100
                                      }deg)`,
                                    }}
                                  ></div>
                                  <div
                                    className="square square2"
                                    style={{
                                      display:
                                        skill?.percentage < 100
                                          ? "block"
                                          : "none",
                                      transform: `rotate(${
                                        (360 *
                                          Math.min(
                                            skill?.percentage - 100,
                                            100
                                          )) /
                                        100
                                      }deg)`,
                                    }}
                                  ></div>
                                  <div
                                    className="square square3"
                                    style={{
                                      display: "none" /* Hide other squares */,
                                    }}
                                  ></div>
                                  <div
                                    className="square square4"
                                    style={{
                                      display: "none" /* Hide other squares */,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))
                          : null}
                      </div>
                    </div>
                  </section>
                  <section>
                    <h3 className="title">Expérience Professionnelle</h3>
                    <div className="timeline">
                      <ul>
                        {candidate?.workExperiences.map((job, index) => (
                          <li key={index}>
                            <time>{moment(job?.startDate).format("YYYY")}</time>
                            <h5>{job?.title}</h5>
                            <p className="p-4">{job?.description}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </section>
                  <section>
                    <h3 className="title">Parcours Scolaires</h3>
                    <div className="timeline">
                      <ul>
                        {candidate?.educations.map((edu, index) => (
                          <li key={index}>
                            <time>{moment(edu?.endYear).format("YYYY")}</time>
                            <h5>{edu?.degree}</h5>
                            <p className="p-4">{edu?.description}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </section>
                  <section>
                    <h3 className="title">Compétences</h3>
                    <div className="software">
                      <ul>
                        {candidate?.skills.map((skill, index) => (
                          <li className="per1" key={index}>
                            {skill?.title}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </section>
                </main>
              </div>
            </div>

            <div className="button-container">
              <button className="btn btn-print" onClick={() => window.print()}>
                Imprimer mon CV
              </button>
              <button className="btn btn-download" onClick={downloadPDF}>
                Télécharger le PDF
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

ResumeTemplate1.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, { getCandidate })(ResumeTemplate1);
